import { useLanguage } from '../../hooks/useLanguage';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-20 px-6 text-center border-t border-[var(--border)]">
      <div className="container max-w-2xl mx-auto space-y-4">
        <h3 className="font-syne font-bold text-2xl text-[var(--text)]">
          {t('closingTitle')}
        </h3>
        <p className="text-[var(--muted)]">
          {t('closingText')}
        </p>
      </div>
    </footer>
  );
};